import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { compose, defaultProps, pure, withProps, withStateHandlers } from 'recompose';
import { FormControl, FormItem, Icon, Label } from '../proxy';

const FormControlItem = ({
  active,
  children,
  className,
  formControlProps,
  formItemProps,
  icon,
  iconProps: {
    className: iconClassName,
    ...otherIconProps
  } = {},
  id,
  label,
  labelProps: {
    className: labelClassName,
    ...otherLabelProps
  } = {},
  onChange,
  readOnly,
  required,
  setActive,
  tag,
  type,
  value
}) => (
    <FormItem {...formItemProps}>
      <Icon
        {...{
          ...otherIconProps,
          icon: icon,
          className: classNames('prefix', { active }, iconClassName)
        }}
      />
      <FormControl
        {...{
          ...formControlProps,
          id: id,
          className,
          onBlur: () => value || setActive(false),
          onChange,
          onFocus: () => setActive(true),
          readOnly,
          required,
          tag,
          type: type,
          value: value
        }}
      />
      <Label
        {...{
          ...otherLabelProps,
          htmlFor: id,
          className: classNames({ active }, labelClassName)
        }}
      >
        {label}
      </Label>
      {children}
    </FormItem>
  );

export default compose(
  defaultProps({
    type: 'text'
  }),
  withStateHandlers(({ value }) => ({
    active: value ? true : false
  }), {
      setActive: () => (active) => ({
        active
      })
    }),
  withProps(({ id, label }) => ({
    label: label !== undefined ?
      label :
      fp.startCase(id)
  })),
  pure
)(FormControlItem);



// WEBPACK FOOTER //
// ./src/components/composed/form-control-item.js